/**
 * What sort of party stands behind a patient's bill. primary owns this vocabulary — the guarantor
 * record stores it, constrained to these values in the database.
 */
export var GuarantorKind;
(function (GuarantorKind) {
    GuarantorKind["Corporate"] = "CORPORATE";
    GuarantorKind["Employee"] = "EMPLOYEE";
    GuarantorKind["MentalHealth"] = "MENTAL_HEALTH";
    GuarantorKind["Other"] = "OTHER";
    GuarantorKind["PersonalFamily"] = "PERSONAL_FAMILY";
    GuarantorKind["RoiRequester"] = "ROI_REQUESTER";
    GuarantorKind["ThirdParty"] = "THIRD_PARTY";
    GuarantorKind["WorkersComp"] = "WORKERS_COMP";
})(GuarantorKind || (GuarantorKind = {}));
//# sourceMappingURL=kind.js.map